import { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  Stack,
  IconButton,
  Button,
  Typography,
  Snackbar,
} from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

import {
  LoginDialog,
  OtpVerificationsDialog,
  selectLoginState,
  SignUpDialogPopup,
} from "@app/modules/auth";
import { imageSource, Strings } from "@app/constants";
import { Footer } from "@app/modules/footer";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { NavbarLogo } from "./nav-bar-logo";
import { NavbarLinks } from "./nav-bar-links";
import { NavbarPopover } from "./nav-bar-popver";
import { NavbarLoader } from "./nav-bar-loader";
import { UserProfileMenu } from "./user-profile-menu/user-profile-menu";
import { ScrollToTopButton } from "./scroll-to-top-buttons";
import Main from "./main";
import { ConfirmDialog } from "./confirm-dialog";
import { useNavbarLogic } from "./nav-bar-logics";
import { WishtlistIcon } from "./wishlistIcon";
import { Iconify } from "../iconify";

const Navbar = () => {
  const {
    openLogoutDialog,
    handleLogoutClick,
    handleConfirmLogout,
    handleCancelLogout,
    contactRef,
    scrollBoxRef,
    showScrollTop,
    scrollToTop,
    anchorEl,
    handlePopoverOpen,
    handlePopoverClose,
    defaultLinks,
    sellCarOption,
    LoginDialogs,
    SignUpDialog,
    otpVerificationsDialogs,
    data,
    isLoading,
    isMobile,
    isAuthenticated,
    theme,
  } = useNavbarLogic();
  const { pathname, hash } = useLocation();
  const [loginFormData, setLoginFormData] = useState();
  const [isDialogClosedOnce, setIsDialogClosedOnce] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    scrollToTop();
  }, [pathname, hash]);

  const firstLoadRef = useRef(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setIsDialogClosedOnce(false);
    }
  }, [pathname]);

  useEffect(() => {
    if (!isAuthenticated) {
      if (!isDialogClosedOnce) {
        LoginDialogs.show();
      }
    } else {
      LoginDialogs.hide();
    }
  }, [isAuthenticated, pathname]);

  // useEffect(() => {
  //   if (firstLoadRef.current && !isAuthenticated && !LoginDialogs.visible) {
  //     LoginDialogs.show();
  //     firstLoadRef.current = false;
  //   }
  // }, [isAuthenticated, LoginDialogs]);
  useEffect(() => {
    handlePopoverClose();
  }, [isMobile]);

  return (
    <Stack sx={{ minHeight: "100vh" }}>
      <AppBar
        elevation={0}
        sx={{
          backgroundColor: theme.palette.common.white,
          width: "100%",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            flexDirection: "column",
            width: "100%",
            height: 10,
          }}
        >
          {isMobile ? (
            <Stack
              sx={{
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                height: "56px",
              }}
            >
              <NavbarLogo />
              <Stack sx={{ pr: 1 }}>
                <IconButton onClick={(e) => isMobile && handlePopoverOpen(e)}>
                  <Iconify icon={"material-symbols:menu-rounded"} />
                </IconButton>
              </Stack>
            </Stack>
          ) : (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              height={"100%"}
              alignSelf={"center"}
            >
              <Stack flexDirection={"row"} height={"100%"} gap={2}>
                <NavbarLogo />
                <NavbarLinks
                  navLinks={defaultLinks}
                  sellCarOption={sellCarOption}
                />
              </Stack>
              <Stack flexDirection={"row"} pr={8} gap={1}>
                {/* <IconButton>
                  <Icon
                    icon={"material-symbols:search"}
                    color={theme.palette.primary.main}
                  />
                </IconButton> */}
                <WishtlistIcon />

                {isAuthenticated ? (
                  <UserProfileMenu
                    userName={`${data?.firstName || ""} ${
                      data?.lastName || ""
                    }`.trim()}
                    onEditProfile={() => {}}
                    onMyOrders={() => {}}
                    onLogout={handleLogoutClick}
                  />
                ) : (
                  <Button
                    onClick={LoginDialogs.show}
                    sx={{
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.common.white,
                      px: 3.5,
                      fontFamily: "Work Sans",
                    }}
                  >
                    {Strings.authPopup.logIn}
                  </Button>
                )}
              </Stack>
            </Stack>
          )}

          <NavbarPopover
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handlePopoverClose}
            handleLogoutClick={handleLogoutClick}
            navLinks={defaultLinks}
            page={0}
            isMobile={isMobile}
          />
        </Toolbar>
      </AppBar>

      <ConfirmDialog
        open={openLogoutDialog}
        title={Strings.userDropDownMenu.logout}
        message={Strings.confirmation.areYouSure}
        onConfirm={handleConfirmLogout}
        onCancel={handleCancelLogout}
      />
      <Stack sx={{ mt: { xs: 7, sm: 8 } }}>
        {isLoading && <NavbarLoader />}
      </Stack>
      {showScrollTop && <ScrollToTopButton onClick={scrollToTop} />}
      <Main ref={scrollBoxRef}>
        <Outlet />
        <Footer ref={contactRef} />
      </Main>

      {LoginDialogs.visible && (
        <LoginDialog
          open={LoginDialogs.visible}
          onClose={() => {
            setIsDialogClosedOnce(true);
            LoginDialogs.hide();
          }}
          // onSignUpClick={() => {
          //   LoginDialogs.hide();
          //   SignUpDialog.show();
          // }}
          onClickOtpVerificationsDialog={() => {
            otpVerificationsDialogs.show();
            LoginDialogs.hide();
          }}
          setLoginFormData={setLoginFormData}
        />
      )}
      {/* {SignUpDialog.visible && (
        <SignUpDialogPopup
          open={SignUpDialog.visible}
          onClose={SignUpDialog.hide}
          onClickLogIn={() => {
            LoginDialogs.show();
            SignUpDialog.hide();
          }}
          onClickOtpVerificationsDialog={() => {
            otpVerificationsDialogs.show();
            SignUpDialog.hide();
          }}
        />
      )} */}
      {otpVerificationsDialogs.visible && (
        <OtpVerificationsDialog
          open={otpVerificationsDialogs.visible}
          onClose={otpVerificationsDialogs.hide}
          // onClickOtpVerifications={() => {
          //   LoginDialogs.show();
          //   SignUpDialog.hide();
          //   otpVerificationsDialogs.hide();
          // }}
          loginFormData={loginFormData}
        />
      )}
    </Stack>
  );
};

export { Navbar };
